<template>
  <div class="analysis-dailog container-block col-block">
    <div class="title-container row-block default-shadow">
      <div class="row-block" :style="{ width: '35px' }"></div>
      <div
        class="title"
        v-html="{
          competitiveness: '單一競爭國之市場競爭力歷年分數表',
          attraction: '單一國家之吸引力指標歷年分數表',
          toolcompetitiveness: '單一競爭國之農業機械市場競爭力歷年分數表',
          toolattraction: '單一國家之農業機械吸引力指標歷年分數表'
        }[analysisType]"
      ></div>
      <div class="row-block close-button" :style="{ width: '35px' }">
        <img :src="require('../../assets/images/analysis-close-icon.svg')" @click="e => $emit('changeModal')">
      </div>
    </div>
    <div class="panel-container" :style="{ flex: 1 }">
      <div v-if="onSearch" class="mask center-block">
        <!-- <img :src="require('../../assets/images/loading.gif')"> -->
        <img :src="require('../../assets/images/upload.svg')" alt="">
      </div>
      <analysisPanel
        :dataType="'year'"
        :country="param.country"
        :datas="datas"
        :tab="param.tab"
        :filterOptions="param.filterOptions"
        :conditions="param.conditions"
      ></analysisPanel>
    </div>
  </div>
</template>

<script>
import { getCompetitivenessDatas, getAttractionDatas } from '../../api'
import analysisPanel from '../../components/analysis/panel'
import routeLoading from '../../mixins/routeLoading'
import toastMethods from '../../mixins/toastMethods'

export default {
  components: {
    analysisPanel
  },
  mixins: [
    routeLoading,
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      datas: [],
      onSearch: false
    }
  },
  computed: {
    analysisType () {
      return this.$route.name
    }
  },
  methods: {
    async fetchData () {
      await this.fetchDatas()
    },
    async fetchDatas () {
      // this.onSearch = true
      try {
        let api = {
          competitiveness: getCompetitivenessDatas,
          attraction: getAttractionDatas,
          toolcompetitiveness: getCompetitivenessDatas,
          toolattraction: getAttractionDatas
        }[this.analysisType]
        let config = this.$ls.get('userInfo')
        let country = {
          competitiveness: this.param.country.country_code,
          attraction: this.param.country.partner_code,
          toolcompetitiveness: this.param.country.country_code,
          toolattraction: this.param.country.partner_code
        }[this.analysisType]
        let conditions = {
          competitiveness: {
            product: this.param.conditions.filters.product,
            country: country,
            partner: this.param.conditions.filters.country
          },
          attraction: {
            product: this.param.conditions.filters.product,
            partner: country
          },
          toolcompetitiveness: {
            product: this.param.conditions.filters.product,
            country: country,
            partner: this.param.conditions.filters.country
          },
          toolattraction: {
            product: this.param.conditions.filters.product,
            partner: country
          }
        }[this.analysisType]
        let response = await api(conditions, config)
        let datas = response.data
        this.datas = datas
      } catch (error) {
        this.datas = []
      }
      this.onSearch = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/analysis.vue